import style from './UserDetails.module.scss'

const UserDetails = () => {
    return(
        <div></div>
    )
}

export default UserDetails